import { fetchFeed, toRows, fundRow, indexRow, pageIndexName, pick, pct, fmtDate, setText } from "./feeds.js";

// Month-end and quarter-end total-return tables. Each feed is expected to carry the
// fund's record plus one row per benchmark (rows with an indexName); the fund row
// uses Ultimus-style keys (oneMonth_Load, marketOneMonth, ...) and the benchmark
// rows the plain keys (oneMonth, ...). Every lookup lists fallbacks so either style works.

const MONTHLY = {
    cols: ["1m", "3m", "ytd", "1y", "5y", "10y", "si"],
    nav: {
        "1m": ["oneMonth_Load", "oneMonth_NoLoad", "oneMonth"],
        "3m": ["threeMonth_Load", "threeMonth_NoLoad", "threeMonth"],
        ytd: ["yearToDate_Load", "yearToDate_NoLoad", "yearToDate"],
        "1y": ["oneYear_Load", "oneYear_NoLoad", "oneYear"],
        "5y": ["fiveYear_Load", "fiveYear_NoLoad", "fiveYear"],
        "10y": ["tenYear_Load", "tenYear_NoLoad", "tenYear"],
        si: ["sinceInception_Load", "sinceInception_NoLoad", "sinceInception", "cummSinceInception_Load"],
    },
    mkt: {
        "1m": ["marketOneMonth"],
        "3m": ["marketThreeMonth"],
        ytd: ["marketYearToDate"],
        "1y": ["marketYear", "marketOneYear"],
        "5y": ["marketFiveYear"],
        "10y": ["marketTenYear"],
        si: ["marketSinceInception", "marketCummSinceInception"],
    },
    index: {
        "1m": ["oneMonth", "oneMonth_Load"],
        "3m": ["threeMonth", "threeMonth_Load"],
        ytd: ["yearToDate", "yearToDate_Load"],
        "1y": ["oneYear", "oneYear_Load"],
        "5y": ["fiveYear", "fiveYear_Load"],
        "10y": ["tenYear", "tenYear_Load"],
        si: ["sinceInception", "sinceInception_Cum", "cummSinceInception"],
    },
};

const QUARTERLY = {
    cols: ["qtd", "ytd", "1y", "5y", "10y", "si"],
    nav: {
        qtd: ["quarterEndToDate_Load", "quarterToDate_Load", "threeMonth_Load", "quarterToDate"],
        ytd: MONTHLY.nav.ytd,
        "1y": MONTHLY.nav["1y"],
        "5y": MONTHLY.nav["5y"],
        "10y": MONTHLY.nav["10y"],
        si: MONTHLY.nav.si,
    },
    mkt: {
        qtd: ["marketQuarterEndToDate", "marketQuarterToDate", "marketThreeMonth"],
        ytd: MONTHLY.mkt.ytd,
        "1y": MONTHLY.mkt["1y"],
        "5y": MONTHLY.mkt["5y"],
        "10y": MONTHLY.mkt["10y"],
        si: MONTHLY.mkt.si,
    },
    index: {
        qtd: ["quarterEndToDate", "quarterToDate", "threeMonth"],
        ytd: MONTHLY.index.ytd,
        "1y": MONTHLY.index["1y"],
        "5y": MONTHLY.index["5y"],
        "10y": MONTHLY.index["10y"],
        si: MONTHLY.index.si,
    },
};

export function getMonthlyPerformance(fundID) {
    return load("get_performance_monthly", fundID, MONTHLY, "m", ".monthly-perf-date");
}

export function getQuarterlyPerformance(fundID) {
    return load("get_performance_quarterly", fundID, QUARTERLY, "q", ".quarterly-perf-date");
}

async function load(feed, fundID, map, prefix, dateSelector) {
    const rows = toRows(await fetchFeed(feed, fundID));
    if (!rows.length) return;

    const fund = fundRow(rows);
    const index = indexRow(rows, pageIndexName());
    const dated = fund || index;
    setText(dateSelector, fmtDate(pick(dated, ["performDate", "asOfDate", "date"])));

    if (fund) {
        fill(prefix + "_nav", fund, map.nav, map.cols);
        fill(prefix + "_mkt", fund, map.mkt, map.cols);
    }
    if (index) fill(prefix + "_index", index, map.index, map.cols);
}

function fill(cls, row, keys, cols) {
    cols.forEach((col) => setText("." + cls + "_" + col, pct(pick(row, keys[col]))));
}
